import { buildEndPoint } from '@mairistem/tools';
import _ from 'lodash';

import { formatFilters, formatSort } from '@/utils';
import baseUrl from './base';

export const getCycles = (
  { page, perPage, sorts, filters } = {
    page: 1,
    perPage: 30,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/cycles`, {
    page,
    perPage: perPage || 30,
    sort: formatSort(sorts),
    ...formatFilters(filters),
  });

export const getCyclesPrelevement = (
  { page } = {
    page: 1,
  },
) =>
  buildEndPoint(`${baseUrl}/cycles`, {
    page,
    perPage: 100,
    datePrelevement: 'isNotNull()',
    etat: 'in(Encaissement en cours)',
  });

export const getCyclesAccueil = (
  { page, perPage, sorts, filters, dateLimiteSince } = {
    page: 1,
    perPage: 30,
    sorts: [],
    filters: [],
    dateLimiteSince: '',
  },
) =>
  buildEndPoint(`${baseUrl}/cycles`, {
    page,
    perPage: perPage || 30,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...(dateLimiteSince && { dateLimite: `since(${dateLimiteSince})` }),
  });

// Cycles en encaissement terminé qui ont au moins une facture impayée total ou partiel
export const getCyclesImpayes = (
  {
    page,
    perPage,
    sorts,
    filters,
    query, // on se sert de cette route pour le search des cycles impayés aussi pour gagner du temps
  } = {
    page: 1,
    perPage: 30,
    sorts: [],
    filters: [],
    query: '',
  },
) =>
  `${buildEndPoint(`${baseUrl}/cycles/impaye`, {
    page,
    perPage: perPage || 30,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...(!_.isEmpty(query) && { titre: `contains(${query})`, caseSensitive: false }),
  })}`;

// Cycles ayant un reste à payer (échus ou non), pour l'écran « Relances et
// impayés » : transferts (cycles échus) et relances avant/après échéance.
export const getCyclesImpayesV2 = (
  {
    page,
    perPage,
    sorts,
    filters,
    query, // on se sert de cette route pour le search des cycles impayés aussi pour gagner du temps
  } = {
    page: 1,
    perPage: 30,
    sorts: [],
    filters: [],
    query: '',
  },
) =>
  `${buildEndPoint(`${baseUrl}/cycles/impaye/v2`, {
    page,
    perPage: perPage || 30,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...(!_.isEmpty(query) && { titre: `contains(${query})`, caseSensitive: false }),
  })}`;

export const searchCycles = (
  { page, query, perPage, sorts, filters } = {
    page: 1,
    query: '',
    perPage: 30,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/cycles/search`, {
    page,
    perPage: perPage || 30,
    q: query,
    sort: formatSort(sorts),
    ...formatFilters(filters),
  });

export const putCycle = (id) => `${baseUrl}/cycles/${id}`;

/** Historise en PDF et CSV la liste des impayés transférés du cycle (body : typeTransfert, seuil) */
export const postEditionImpayes = (cycleId: number) =>
  `${baseUrl}/cycles/${cycleId}/edition-impayes`;

export const postFluxImpayees = (
  cycleId: number,
  {
    typeTransfert = 'facture',
    seuil = 0,
  }: {
    typeTransfert?: string;
    seuil?: number;
  } = {},
) =>
  buildEndPoint(`${baseUrl}/cycles/${cycleId}/flux-impayees`, {
    prelevee: 'rejetee',
    ...(typeTransfert === 'payeur'
      ? { montantAEncaisserPayeur: `greaterOrEqual(${seuil})` }
      : { montantAEncaisser: `greaterOrEqual(${seuil})` }),
  });
